import { render, staticRenderFns } from "./CustomerFormInfoModal.vue?vue&type=template&id=bb7aa462&scoped=true&"
import script from "./CustomerFormInfoModal.vue?vue&type=script&lang=js&"
export * from "./CustomerFormInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormInfoModal.vue?vue&type=style&index=0&id=bb7aa462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7aa462",
  null
  
)

export default component.exports